import { DateRangeFieldProps } from "./DateRangeField";
import { useCallback, useState } from "react";
import { DateRangeFieldValue } from "../../types/fieldTypes";
import { format, parse } from "date-fns";

export const useDateRangeField = (props: DateRangeFieldProps) => {
  const [localDates, setLocalDates] = useState<DateRangeFieldValue>(
    props.value
  );
  const dateFnsFormat = "MM/dd/yyyy";
  const formatDate = useCallback(
    (date: Date) => format(date, dateFnsFormat),
    []
  );
  const parseDate = useCallback(
    (str: string) => parse(str, dateFnsFormat, new Date()),
    []
  );

  return { localDates, setLocalDates, formatDate, parseDate };
};
